import { ECampaignType } from "models/api/enums/ECampaignType";
import { UIProduct } from "models/content/product/UIProduct";
import { Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useAppDispatch } from "../../store/hooks";
import { toggleProductModal } from "../../store/slices/uiSlice";
import { ProductImage } from "../ui/images/product-image/product-image";

interface IProps {
    product: UIProduct;
}

export const RelatedProductCard = ({ product }: IProps) => {
    const dispatch = useAppDispatch();

    const getCampaignTag = () => {
        if (!product.uiAttributes.campaign) return <></>;

        return (
            <span className={`ms-1 ${product.uiAttributes.campaign.type === ECampaignType.RegularCampaign ? "text-dark" : "text-danger"}`}>
                <sup>
                    <FormattedMessage id={`product.campaign.${product.uiAttributes.campaign.type}`} />
                </sup>
            </span>
        );
    };

    return (
        <Col
            xs={12}
            onClick={() => dispatch(toggleProductModal(product, { source: "related" }))}
            className={"cursor-pointer d-flex gap-1 align-items-center position-relative"}
        >
            <ProductImage id={product.id} item={product} size={"md"} useZoom={false} />
            <div>
                {product.uiAttributes.productName || product.name}
                {getCampaignTag()}
            </div>
        </Col>
    );
};
